import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import cookie from "react-cookies";

import { seenSystemNotify } from "../../model/profile";
import { getLoggedProfile, logout } from "../../actions/sessionAct";

import { commonErr } from "../common/errors";
import { LoadingInline } from "../common/loading";
import { LogoutBox } from "../common/logout";

import Login from "../login/login";
import SignUp from "../login/signup";
import Notifications from "../account/notifications";

import { IcChevrDown, IcChevrLeft, IcHamburger, IcLogOut } from "../common/svg";
import {
	OWNER_REGISTER,
	ABOUT_US,
	ACCOUNT,
	MODE_REGISTER,
	HOME,
	MY_FAVS,
	MY_TRIPS,
	MY_REWARD,
	MY_CARS,
} from "../../constant/routes";

import avatar_default from "../../static/images/avatar_default.png";

import logo_full from "../../static/images/logo/logo-full.png";
import logo_short from "../../static/images/logo/logo-short.png";

class GuestMenu extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			showLogin: false,
			showSignup: false,
		};
	}

	componentDidMount() {
		const pathname = cookie.load("_mpathdirect");
		if (pathname) {
			this.setState({
				showLogin: true,
			});
		}
	}

	openSignupForm = () => {
		cookie.remove("_mpathdirect", { path: "/" });
		this.setState({
			showSignup: true,
			showLogin: false,
		});
	};

	closeSignupForm = () => {
		this.setState({
			showSignup: false,
		});
	};

	openLoginForm = () => {
		this.setState({
			showLogin: true,
		});
	};

	closeLoginForm = () => {
		const cookieDirect = cookie.load("_mpathdirect");
		if (cookieDirect) {
			cookie.save("_mpathOTP", cookieDirect, { path: "/" });
			cookie.remove("_mpathdirect", { path: "/" });
		}
		this.setState({
			showLogin: false,
		});
	};

	render() {
		const { isShowMenu, carFinding } = this.props;
		const { showLogin, showSignup } = this.state;
		return (
			<>
				{!carFinding && (
					<>
						<a className="btn btn--s sign-in" onClick={this.openSignupForm}>
							Đăng ký
						</a>
						<a className="btn btn--s" onClick={this.openLoginForm}>
							Đăng nhập
						</a>
					</>
				)}
				<a className="dropdown-profile" onClick={() => this.props.toggleMenu()}>
					<div className="wrap-svg tab-menu">
						<IcHamburger />
					</div>
				</a>
				<Login
					show={showLogin}
					showModal={this.openLoginForm}
					hideModal={this.closeLoginForm}
					openSignupForm={this.openSignupForm}
					getLoggedProfile={this.props.getLoggedProfile}
				/>
				<SignUp
					show={showSignup}
					showModal={this.openSignupForm}
					hideModal={this.closeSignupForm}
					openLoginForm={this.openLoginForm}
					getLoggedProfile={this.props.getLoggedProfile}
				/>
				<div className={`menu-mobile ${isShowMenu ? "open" : "open move-left"}`}>
					<div className="header-menu">
						{/* <a className="logo-container">
							<div className="full-logo"> 
								<img src="images/logo/logo-full.png" alt="" /></div>
							</a> */}
						<div className="close-menu" onClick={() => this.props.closeMenu()}>
							×
						</div>
					</div>
					<div className="m-container">
						<div className="menu-list">
							<a className="menu-list__item" onClick={this.openLoginForm}>
								Đăng nhập
							</a>
							<div className="line-page" />
							<a className="menu-list__item" onClick={this.openSignupForm}>
								Đăng ký
							</a>
						</div>
						<div className="menu-list">
							<Link to={ABOUT_US} onClick={() => this.props.closeMenu()} className="menu-list__item">
								Về Mioto
							</Link>
							<div className="line-page" />
							<Link to={OWNER_REGISTER} onClick={() => this.props.closeMenu()} className="menu-list__item">
								Trở thành chủ xe
							</Link>
						</div>
					</div>
				</div>
			</>
		);
	}
}

class LoggedMenu extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			showChangePassword: false,
			hasPromo: false,
			hasNewUp: false,
			isLogoutBox: false,
		};
	}

	componentDidMount() {
		document.addEventListener("mousedown", this.handleClickOutside);
	}

	UNSAFE_componentWillUnmount() {
		document.removeEventListener("mousedown", this.handleClickOutside);
	}

	componentDidUpdate(props) {
		const snotis = this.props.appInit.data.snotifs;

		if (snotis != props.appInit.data.snotifs) {
			const snoti = snotis.filter((n) => {
				return n.type === 3 /*PROMO NOTI*/ && n.reddot > 0;
			});
			const unoti = snotis.filter((n) => {
				return n.type === 2 /*PROMO NOTI*/ && n.reddot > 0;
			});
			if (snoti && snoti.length > 0) {
				this.setState({
					hasPromo: true,
				});
			}
			if (unoti && unoti.length > 0) {
				this.setState({
					hasNewUp: true,
				});
			}
		}
	}

	onMyTripsClick = () => {
		const snotis = this.props.appInit.data.snotifs;
		if (snotis) {
			const snoti = snotis.filter((n) => {
				return n.type === 2 /*UPCOMMING NOTI*/ && n.reddot > 0;
			});
			if (snoti && snoti.length > 0) {
				seenSystemNotify(snoti[0].id, snoti[0].type);
				window.location.href = "/mytrips";
				return;
			}
		}

		window.location.href = "/mytrips";
	};

	onPromoLinkClick = () => {
		const snotis = this.props.appInit.data.snotifs;
		if (snotis) {
			const snoti = snotis.filter((n) => {
				return n.type === 3 /*UPCOMMING NOTI*/ && n.reddot > 0;
			});
			if (snoti && snoti.length > 0) {
				seenSystemNotify(snoti.id, snoti.type).then((resp) => {
					window.location.href = "/promo";
					return;
				});
			}
		}
		window.location.href = "/promo";
	};

	showChangePassword = () => {
		this.setState({
			showChangePassword: true,
		});
	};

	hideChangePassword = () => {
		this.setState({
			showChangePassword: false,
		});
	};

	/**
	 * Set the wrapper ref
	 */
	setWrapperRef = (node) => {
		this.wrapperRef = node;
	};

	/**
	 * Alert if clicked on outside of element
	 */
	handleClickOutside = (event) => {
		if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
			this.props.closeDropdown();
		}
	};

	showConfirmLogout = () => {
		this.props.closeMenu();
		this.setState({
			isLogoutBox: true,
		});
	};

	hideConfirmLogout = () => {
		this.setState({
			isLogoutBox: false,
		});
	};

	logout = () => {
		this.props.dispatch(logout());
	};

	render() {
		const { profile, isShowMenu, carFinding } = this.props;
		const { isLogoutBox } = this.state;
		return (
			<>
				<div className="dropdown-profile">
					{!carFinding && (
						<Link className="dropdown-profile" to={ACCOUNT}>
							<div className="avatar avatar--s">
								<img
									loading="lazy"
									src={profile.avatar && profile.avatar.thumbUrl ? profile.avatar.thumbUrl : avatar_default}
									alt={profile.name}
								/>
							</div>
							<span className="name">{profile.name}</span>
							<div className="wrap-svg">
								<IcChevrDown />
							</div>
						</Link>
					)}
					<div className="wrap-svg tab-menu" onClick={() => this.props.toggleMenu()}>
						<IcHamburger />
					</div>
				</div>
				<div className={`menu-mobile ${isShowMenu ? "open" : "open move-left"}`}>
					<div className="header-menu">
						<div className="close-menu" onClick={() => this.props.closeMenu()}>
							×
						</div>
					</div>
					<div className="m-container">
						<div className="menu-list">
							<Link to={ACCOUNT} onClick={() => this.props.closeMenu()} className="menu-avatar">
								<div className="avatar avatar--s">
									<img
										loading="lazy"
										src={profile.avatar && profile.avatar.thumbUrl ? profile.avatar.thumbUrl : avatar_default}
										alt={profile.name}
									/>
								</div>
								<span className="name">{profile.name}</span>
							</Link>
							<div className="line-page" />
							<Link to={MY_CARS} onClick={() => this.props.closeMenu()} className="menu-list__item">
								Xe của tôi
							</Link>
							<div className="line-page" />
							<Link to={MY_FAVS} onClick={() => this.props.closeMenu()} className="menu-list__item">
								Xe yêu thích
							</Link>
							<div className="line-page" />
							<Link to={MY_REWARD} onClick={() => this.props.closeMenu()} className="menu-list__item">
								Quà tặng
							</Link>
						</div>

						<div className="menu-list">
							<Link to={ABOUT_US} onClick={() => this.props.closeMenu()} className="menu-list__item">
								Về Mioto
							</Link>
							<div className="line-page" />
							<Link to={MODE_REGISTER} onClick={() => this.props.closeMenu()} className="menu-list__item">
								Trở thành chủ xe
							</Link>
							<div className="line-page" />
							<Link to={MY_TRIPS} onClick={() => this.props.closeMenu()} className="menu-list__item">
								Chuyến của tôi
							</Link>
						</div>

						<a className="menu-logout" onClick={this.showConfirmLogout}>
							<div className="wrap-svg">
								<IcLogOut />
							</div>
							Đăng xuất
						</a>
					</div>
				</div>
				<LogoutBox show={isLogoutBox} onHide={this.hideConfirmLogout} onLogout={this.logout} />
			</>
		);
	}
}

function mapAppInitState(state) {
	return {
		appInit: state.appInit,
	};
}

LoggedMenu = connect(mapAppInitState)(LoggedMenu);

class HeaderBar extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isShowDropdown: false,
			isShowNotify: false,
			err: commonErr.INNIT,
			notis: null,
			isShowMenu: false,
		};
	}

	getLoggedProfile = () => {
		this.props.dispatch(getLoggedProfile());
	};

	logout = () => {
		this.props.dispatch(logout());
	};

	toggleDropdown = () => {
		this.setState({
			isShowDropdown: !this.state.isShowDropdown,
		});
	};

	toggleNotify = () => {
		this.setState({
			isShowNotify: !this.state.isShowNotify,
		});
	};

	toggleMenu = () => {
		this.setState({
			isShowMenu: !this.state.isShowMenu,
		});
	};

	closeMenu = () => {
		this.setState({
			isShowMenu: false,
		});
	};

	closeDropdown = () => {
		this.setState({
			isShowDropdown: false,
		});
	};

	closeNotify = () => {
		this.setState({
			isShowNotify: false,
		});
	};

	render() {
		var menuCont;
		const { session, notLineHeader, fixed, visible, carFinding, children } = this.props;
		const { isShowMenu, isShowDropdown, isShowNotify } = this.state;
		if (session.profile.err === commonErr.LOADING) {
			menuCont = (
				<div className="menu-container">
					<LoadingInline />
				</div>
			);
		} else if (session.profile && session.profile.info && session.profile.info.uid) {
			menuCont = (
				<LoggedMenu
					isShowDropdown={isShowDropdown}
					toggleDropdown={this.toggleDropdown}
					closeDropdown={this.closeDropdown}
					logout={this.logout}
					profile={session.profile.info}
					isShowMenu={isShowMenu}
					toggleMenu={this.toggleMenu}
					closeMenu={this.closeMenu}
					carFinding={carFinding}
				/>
			);
		} else {
			menuCont = (
				<GuestMenu
					getLoggedProfile={this.getLoggedProfile}
					isShowMenu={isShowMenu}
					toggleMenu={this.toggleMenu}
					closeMenu={this.closeMenu}
					carFinding={carFinding}
				/>
			);
		}

		return (
			<section
				className={`header ${notLineHeader ? "" : "line-header"} ${fixed ? "fixed" : ""} ${
					visible ? "" : "scroll-top"
				} ${carFinding ? "car-finding" : ""}`}>
				<div className="m-container">
					<a className="logo-container" href={HOME}>
						{carFinding ? (
							<div className="wrap-svg back">
								<IcChevrLeft />
							</div>
						) : (
							<>
								<div className="full-logo">
									<img loading="lazy" src={logo_full} alt="Mioto" />
								</div>
								<div className="short-logo">
									<img loading="lazy" src={logo_short} alt="Mioto" />
								</div>
							</>
						)}
					</a>
					{children}
					<div className="menu-container">
						{!carFinding && (
							<>
								<Link to={ABOUT_US}>Về Mioto</Link>
								<Link
									to={
										session.profile && session.profile.info && session.profile.info.uid ? MODE_REGISTER : OWNER_REGISTER
									}>
									Trở thành chủ xe
								</Link>
								{session.profile && session.profile.info && session.profile.info.uid && (
									<Link to={MY_TRIPS}>Chuyến của tôi</Link>
								)}
								<div className="vertical-line"></div>
								<Notifications
									isLogged={session.profile && session.profile.info && session.profile.info.uid}
									isShowNotify={isShowNotify}
									toggleNotify={this.toggleNotify}
									closeNotify={this.closeNotify}
								/>
							</>
						)}
						{menuCont}
					</div>
				</div>
			</section>
		);
	}
}

function mapState(state) {
	return {
		session: state.session,
	};
}

HeaderBar = connect(mapAppInitState)(HeaderBar);
HeaderBar = connect(mapState)(HeaderBar);
export default HeaderBar;
